// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1e89faca","239":"4023b14d","453":"ff0b84ff","455":"a0f32bcf"}[chunkId] + ".chunk.js";
};